// extracted by mini-css-extract-plugin
module.exports = {"feedbackMenu":"FeedbackMenu-feedbackMenu--071ab","feedbackMenu__bp":"FeedbackMenu-feedbackMenu__bp--7ef4c"};